import { render, staticRenderFns } from "./freqTable.vue?vue&type=template&id=2b7ad9a2&"
import script from "./freqTable.vue?vue&type=script&lang=js&"
export * from "./freqTable.vue?vue&type=script&lang=js&"
import style0 from "./freqTable.vue?vue&type=style&index=0&id=2b7ad9a2&prod&scpoed=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports